import { useQuery } from 'react-query';

import { getMappedContracts as queryFn } from 'api/endPoints/getMappedContracts';
import { QueryKeys } from 'api/queryKeys';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { IPhasePerformanceContracts } from 'components/widgets/PhasePerformanceChart/PhasePerformance.types';

export const useQueryPhasePerformanceGetContracts = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getMappedContracts', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.templateId),
    });
};

export interface QueryParams {
    templateId?: number;
    filter: {
        filters: IFilter[];
    };
}

export interface QueryFnResponse {
    mapped_contracts: IPhasePerformanceContracts[];
    phase_performance_breakdown_info: IToolTip;
    phase_performance_chart_info: IToolTip;
}

type QueryResponse = QueryFnResponse & {};
